// extracted by mini-css-extract-plugin
module.exports = {"lia-remove":"TagRemoveButton_lia-remove__201OE","lia-remove-icon":"TagRemoveButton_lia-remove-icon__N8j8Q"};